module.exports = __webpack_public_path__ + "static/media/agent-people.190de4b0.svg";